/* global $, logEvent */
import React from 'react';
import { useLocation, useNavigate,useSearchParams  } from 'react-router-dom';
import { makeAPI } from '../services/api';
import nav_arrow from "/src/assets/img/icons/prev_nxt.avif";
import {getViteImage} from '../utils/utils';

const avatarImages = import.meta.glob('../assets/img/profile_avatar/*.avif', {
    eager: true,
    import: 'default'
});

export default function MVP() {
    const user = JSON.parse(localStorage.getItem("user")) || {};
    const [winners_obj, setwinners_obj] = React.useState({});
    const [rewards_obj, setrewards_obj] = React.useState({});
    const [toggle, settoggle] = React.useState('');
    const [prev_id, setprev] = React.useState(0);
    const [next_id, setnext] = React.useState(0);
    const [title, settitle] = React.useState("");
    const [duration_txt, setduration_txt] = React.useState("");
    const [request_user, setrequest_user] = React.useState("");
    const [is_sponser, setis_sponser] = React.useState(false);
    const [sponser_data, setsponser_data] = React.useState({});
    const [animate, setanimate] = React.useState(false);
    const location = useLocation();
    // const params = useSearchParams();
    // const navigate = useNavigate();
    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);
    const { state } = location;
    const MVP_event_id = state?.value || params.get('id');

    React.useEffect(() => {
        document.title = "MVP - CGES.CLUB";
        getMVPLeaderboard();
        return () => {
        };
    }, []);

    async function getMVPLeaderboard(selection_id, user_id) {
        
        
        let arrow_selection;
        let event_id = 0;
        user_id = user?.user_id;

        if (selection_id === "prev") {
            arrow_selection = document.getElementById('arrow-prev');
            event_id = prev_id;
            if (prev_id === 0 && arrow_selection) arrow_selection.disabled = true;
        } else if (selection_id === "next") {
            arrow_selection = document.getElementById('arrow-next');
            event_id = next_id;
            if (next_id === 0 && arrow_selection) arrow_selection.disabled = true;
        }
        // console.log("ID'S",MVP_event_id,selection_id);

        if(MVP_event_id && selection_id=== undefined) {
            event_id = MVP_event_id;
        }

        console.log("MVP SELECTION", event_id, selection_id);

        const payload = {
            event_id,
            user_id
        };

        const mvp_data = await makeAPI('/api/mvp', 'POST', user_id, payload);
        if (mvp_data.status === "S") {
            setwinners_obj(mvp_data.data.winners_obj);
            setrewards_obj(mvp_data.data.rewards_obj);
            setrequest_user(mvp_data.data.requested_user);
            settitle(mvp_data?.data?.title || "");
            setnext(mvp_data?.data?.next_id || 0);
            setprev(mvp_data?.data?.prev_id || 0);
            setduration_txt(`${mvp_data?.data?.first_date || ''} to ${mvp_data?.data?.last_date || ''}`);
            setis_sponser(Boolean(mvp_data?.data?.sponser?.brand_name));
            setsponser_data(mvp_data?.data?.sponser || {});
            setanimate(mvp_data?.data?.rewards_animate || false);
        }
    }

    const players = {
        1: {
            rank: winners_obj[0]?.rank || 1,
            name: winners_obj[0]?.name || "--",
            profile_avatar: winners_obj[0]?.profile_avatar || "",
            profile_img: winners_obj[0]?.profile_img || "",
            reward_img_url: rewards_obj[0]?.thumb_img || "/assets/img/placeholder.png",
            reward_title: rewards_obj[0]?.title || '--',
            reward_subtitle: rewards_obj[0]?.sub_title || '--',
            earned_coins: winners_obj[0]?.earned_coins || '--'
        },
        2: {
            rank: winners_obj[1]?.rank || 2,
            name: winners_obj[1]?.name || "--",
            profile_avatar: winners_obj[1]?.profile_avatar || "",
            profile_img: winners_obj[1]?.profile_img || "",
            reward_img_url: rewards_obj[1]?.thumb_img || "/assets/img/placeholder.png",
            reward_title: rewards_obj[1]?.title || '--',
            reward_subtitle: rewards_obj[1]?.sub_title || '--',
            earned_coins: winners_obj[1]?.earned_coins || '--'
        },
        3: {
            rank: winners_obj[2]?.rank || 3,
            name: winners_obj[2]?.name || "--",
            profile_avatar: winners_obj[2]?.profile_avatar || "",
            profile_img: winners_obj[2]?.profile_img || "",
            reward_img_url: rewards_obj[2]?.thumb_img || "/assets/img/placeholder.png",
            reward_title: rewards_obj[2]?.title || '--',
            reward_subtitle: rewards_obj[2]?.sub_title || '--',
            earned_coins: winners_obj[2]?.earned_coins || '--'
        }
    };

    const rankSuffix = (rank) => {
        if (!rank) return "th";
        if (rank % 100 >= 11 && rank % 100 <= 13) return "th";
        if (rank % 10 === 1) return "st";
        if (rank % 10 === 2) return "nd";
        if (rank % 10 === 3) return "rd";
        return "th";
    };

    const rankTheme = {
        1: { card: "mvp-card card-gold", ribbon: "rank-ribbon rank-1" },
        2: { card: "mvp-card card-silver", ribbon: "rank-ribbon rank-2" },
        3: { card: "mvp-card card-bronze", ribbon: "rank-ribbon rank-3" }
    };
    const sponsorHref = sponser_data?.link || '#';
    const sponsorBrand = sponser_data?.brand_name || 'Our Partner';
    const sponsorImage = sponser_data?.img_url || '/assets/img/placeholder.png';

    const getAvatarSrc = (profile_img, profile_avatar) => {
        if (profile_img) return profile_img;
        const key = `../assets/img/profile_avatar/${profile_avatar || 0}.avif`;
        return avatarImages[key] || avatarImages['../assets/img/profile_avatar/0.avif'] || '/assets/img/placeholder.png';
    };

    return (
        <>
            <div className="top-advisors-area pd-top-120 mvp-shell">
                <div className="row justify-content-center">
                    <div className="col-lg-6">
                        <div className="section-title text-center mvp-header">
                            <h5>MVP RANKING</h5>
                            <div className="mvp-period-switcher">
                                <button
                                    type="button"
                                    className={`mvp-nav-btn nav-prev ${toggle === "prev" ? "is-active" : ""}`}
                                    value={prev_id}
                                    id="arrow-prev"
                                    disabled={prev_id === 0}
                                    onClick={() => {
                                        getMVPLeaderboard('prev');
                                        settoggle('prev');
                                    }}
                                >
                                    <img
                                        src={nav_arrow}
                                        alt="prev"
                                        width={18}
                                        className="nav-icon nav-icon-prev"
                                    />
                                    <span>Prev</span>
                                </button>

                                <div className="mvp-period-pill" role="status" aria-live="polite">
                                    <span className="period-tag">Current Season</span>
                                    <span className="period-name">{(title || 'Current').toUpperCase()}</span>
                                </div>

                                <button
                                    type="button"
                                    className={`mvp-nav-btn nav-next ${toggle === "next" ? "is-active" : ""}`}
                                    value={next_id}
                                    id="arrow-next"
                                    disabled={next_id === 0}
                                    onClick={() => {
                                        getMVPLeaderboard('next');
                                        settoggle('next');
                                    }}
                                >
                                    <img
                                        src={nav_arrow}
                                        alt="next"
                                        width={18}
                                        className="nav-icon"
                                    />
                                    <span>Next</span>
                                </button>
                            </div>
                            <h6 className="mvp-duration-chip"><span>Duration:</span> {duration_txt || '--'} (IST)</h6>
                        </div>
                    </div>
                </div>
            </div>

            <div className="text-white pt-3 font-sans" id="mvp-div">
                <style>{`
                    :root {
                        --mvp-bg: #000000;
                        --mvp-text: #f5f5f5;
                        --mvp-muted: #b3b3b3;
                        --mvp-accent: #ff810e;
                        --mvp-accent-soft: #ffb869;
                        --mvp-border: rgba(255, 255, 255, 0.12);
                        --mvp-glass: rgba(22, 22, 22, 0.88);
                    }

                    body {
                        font-family: 'Space Grotesk', 'Segoe UI', Tahoma, sans-serif;
                        background:
                            radial-gradient(900px 450px at 20% 0%, rgba(255, 129, 14, 0.22), transparent 60%),
                            radial-gradient(900px 450px at 80% 0%, rgba(255, 129, 14, 0.12), transparent 62%),
                            var(--mvp-bg);
                        color: var(--mvp-text);
                        min-height: 100vh;
                    }

                    #mvp-div {
                        padding-top: 14px !important;
                        position: relative;
                    }

                    .mvp-shell {
                        position: relative;
                        z-index: 1;
                    }

                    .mvp-header {
                        margin-bottom: 0;
                        color: var(--mvp-text);
                        padding: 14px 14px 10px;
                        border-radius: 16px;
                        background: linear-gradient(140deg, rgba(22, 22, 22, 0.94), rgba(0, 0, 0, 0.94));
                        border: 1px solid rgba(255, 129, 14, 0.2);
                        box-shadow: 0 12px 28px rgba(0, 0, 0, 0.28);
                    }

                    .mvp-header h5 {
                        color: var(--mvp-muted);
                        letter-spacing: 0.22em;
                        font-size: 0.78rem;
                        font-weight: 700;
                        margin-bottom: 8px;
                    }

                    .mvp-title-row {
                        color: var(--mvp-text);
                        font-weight: 700;
                        letter-spacing: 0.02em;
                    }

                    .mvp-header h6 {
                        color: var(--mvp-accent);
                        font-weight: 500;
                    }

                    .mvp-period-switcher {
                        display: grid;
                        grid-template-columns: 94px 1fr 94px;
                        gap: 10px;
                        align-items: center;
                        margin-bottom: 10px;
                    }

                    .mvp-nav-btn {
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        gap: 6px;
                        height: 42px;
                        border-radius: 12px;
                        border: 1px solid rgba(255, 255, 255, 0.2);
                        background: linear-gradient(140deg, rgba(22, 22, 22, 0.95), rgba(0, 0, 0, 0.95));
                        color: #f5f5f5;
                        font-weight: 600;
                        font-size: 13px;
                        transition: all 0.2s ease;
                    }

                    .mvp-nav-btn:hover:not(:disabled) {
                        border-color: rgba(255, 129, 14, 0.8);
                        box-shadow: 0 8px 16px rgba(255, 129, 14, 0.2);
                        transform: translateY(-1px);
                    }

                    .mvp-nav-btn.is-active {
                        border-color: rgba(255, 129, 14, 0.9);
                        box-shadow: inset 0 0 0 1px rgba(255, 129, 14, 0.45), 0 8px 16px rgba(255, 129, 14, 0.2);
                    }

                    .mvp-nav-btn:disabled {
                        opacity: 0.42;
                        cursor: not-allowed;
                    }

                    .nav-icon {
                        display: block;
                        filter: brightness(0) invert(1);
                    }

                    .nav-icon-prev {
                        transform: rotate(180deg);
                    }

                    .mvp-period-pill {
                        min-height: 50px;
                        border-radius: 14px;
                        border: 1px solid rgba(255, 129, 14, 0.4);
                        background: linear-gradient(130deg, rgba(255, 129, 14, 0.22), rgba(22, 22, 22, 0.95));
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        padding: 8px 12px;
                        overflow: hidden;
                    }

                    .period-tag {
                        font-size: 10px;
                        text-transform: uppercase;
                        letter-spacing: 0.12em;
                        color: #ffbc73;
                        font-weight: 700;
                        line-height: 1.2;
                    }

                    .period-name {
                        font-size: 17px;
                        line-height: 1.2;
                        color: #ffffff;
                        font-weight: 700;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }

                    .mvp-duration-chip {
                        margin: 0;
                        padding: 8px 12px;
                        border-radius: 999px;
                        display: inline-flex;
                        align-items: center;
                        gap: 6px;
                        border: 1px solid rgba(255, 129, 14, 0.34);
                        background: rgba(255, 129, 14, 0.12);
                        color: #ffbc73;
                        font-size: 13px;
                    }

                    .mvp-duration-chip span {
                        color: #ffd8b0;
                        font-weight: 700;
                    }

                    .sponsor-hero {
                        margin-bottom: 8px;
                        border-radius: 16px;
                        border: 1px solid rgba(255, 129, 14, 0.35);
                        background:
                            linear-gradient(130deg, rgba(255,129,14,0.24), rgba(22,22,22,0.9)),
                            linear-gradient(180deg, rgba(255,255,255,0.08), rgba(0,0,0,0.1));
                        overflow: hidden;
                        box-shadow: 0 16px 34px rgba(0, 0, 0, 0.34);
                    }

                    .sponsor-media {
                        position: relative;
                        display: block;
                        overflow: hidden;
                    }

                    .sponsor-media::after {
                        content: "";
                        position: absolute;
                        inset: 0;
                        background: linear-gradient(to top, rgba(0, 0, 0, 0.72), rgba(0, 0, 0, 0.08) 55%);
                    }

                    .sponsor-head {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        padding: 12px 14px 8px;
                    }

                    .sponsor-tag {
                        font-size: 11px;
                        text-transform: uppercase;
                        letter-spacing: 0.15em;
                        color: #ffca88;
                        font-weight: 700;
                    }

                    .sponsor-pill {
                        font-size: 11px;
                        padding: 3px 10px;
                        border-radius: 999px;
                        border: 1px solid rgba(255, 129, 14, 0.45);
                        background: rgba(255, 129, 14, 0.14);
                    }

                    .sponsor-banner {
                        width: 100%;
                        max-height: 190px;
                        object-fit: cover;
                        display: block;
                    }

                    .sponsor-overlay {
                        position: absolute;
                        left: 12px;
                        right: 12px;
                        bottom: 10px;
                        z-index: 2;
                        display: flex;
                        align-items: end;
                        justify-content: space-between;
                        gap: 10px;
                    }

                    .sponsor-copy {
                        font-size: 13px;
                        color: #fff3e3;
                        line-height: 1.3;
                        text-shadow: 0 2px 8px rgba(0, 0, 0, 0.45);
                    }

                    .sponsor-cta {
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        padding: 7px 12px;
                        border-radius: 999px;
                        background: linear-gradient(135deg, #ff9a2d, #ff6f00);
                        border: 1px solid rgba(255, 255, 255, 0.35);
                        color: #121212;
                        font-size: 12px;
                        font-weight: 700;
                        letter-spacing: 0.02em;
                        white-space: nowrap;
                        box-shadow: 0 8px 18px rgba(255, 122, 10, 0.45);
                    }

                    .ad-strip {
                        border-radius: 12px;
                        padding: 11px 14px;
                        margin-bottom: 16px;
                        border: 1px dashed rgba(255, 129, 14, 0.55);
                        color: #f5d3ad;
                        background: linear-gradient(110deg, rgba(255,129,14,0.18), rgba(255,255,255,0.04));
                        font-size: 13px;
                    }

                    .mvp-stack {
                        display: flex;
                        flex-direction: column;
                        gap: 12px;
                    }

                    .mvp-card {
                        border-radius: 16px;
                        overflow: hidden;
                        border: 1px solid var(--mvp-border);
                        background: linear-gradient(130deg, rgba(24,24,24,0.95), rgba(0,0,0,0.95));
                        backdrop-filter: blur(8px);
                        transition: transform 0.25s ease, box-shadow 0.25s ease;
                        padding: 4px;
                    }

                    .mvp-card:hover {
                        transform: translateY(-4px);
                        box-shadow: 0 16px 28px rgba(0, 0, 0, 0.42);
                    }

                    .card-gold {
                        background: linear-gradient(130deg, rgba(255, 192, 89, 0.42), rgba(112, 70, 13, 0.52));
                    }

                    .card-silver {
                        background: linear-gradient(130deg, rgba(255, 154, 45, 0.22), rgba(22, 22, 22, 0.95));
                    }

                    .card-bronze {
                        background: linear-gradient(130deg, rgba(197, 128, 89, 0.42), rgba(68, 33, 22, 0.54));
                    }

                    .mvp-card-body {
                        background: var(--mvp-glass);
                        border-radius: 12px;
                        padding: 10px;
                    }

                    .rank-badge {
                        position: relative;
                        width: 100%;
                        flex-shrink: 0;
                    }

                    .rank-ribbon {
                        position: absolute;
                        top: -1px;
                        left: 5px;
                        width: 30px;
                        height: 40px;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        font-size: 16px;
                        font-weight: bold;
                        z-index: 2;
                        clip-path: polygon(50% 0, 100% 0, 100% 100%, 50% 75%, 0 100%, 0 0);
                    }

                    .rank-ribbon::after {
                        content: '';
                        position: absolute;
                        inset: 0;
                        background: url('data:image/svg+xml;utf8,<svg width="30" height="40" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none"><polygon points="15,0 30,0 30,40 15,30 0,40 0,0" fill="none" stroke="white" stroke-width="3"/></svg>');
                        background-size: 100% 100%;
                        background-repeat: no-repeat;
                        pointer-events: none;
                        z-index: 1;
                    }

                    .rank-1 { background: linear-gradient(135deg, #ffe188, #ffb85e); color: #3f2300; }
                    .rank-2 { background: linear-gradient(135deg, #ffd9ad, #ff9b36); color: #311908; }
                    .rank-3 { background: linear-gradient(135deg, #ffdcbc, #cb8b61); color: #311908; }

                    .product-image {
                        width: 100%;
                        aspect-ratio: 1;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border-radius: 10px;
                        overflow: hidden;
                        background: rgba(255, 255, 255, 0.08);
                    }

                    .product-image > img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }

                    .award-title {
                        font-size: 18px;
                        font-weight: 700;
                        margin-bottom: 4px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }

                    .award-subtitle {
                        font-size: 14px;
                        color: var(--mvp-muted);
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }

                    .users-info {
                        background: rgba(0, 0, 0, 0.68);
                        border-radius: 10px;
                        padding: 9px 10px;
                        margin-top: 10px;
                        border: 1px solid rgba(255, 255, 255, 0.08);
                    }

                    .user-avatar,
                    .user-avatar img {
                        width: 35px;
                        height: 35px;
                        border-radius: 50%;
                        background: #161616;
                        flex-shrink: 0;
                    }

                    .sleek-card {
                        display: flex;
                        align-items: center;
                        gap: 12px;
                        padding: 8px;
                        border-radius: 12px;
                        background: linear-gradient(135deg, #161616, #000000);
                        border: 1px solid rgba(255, 255, 255, 0.08);
                        box-shadow: 0 10px 24px rgba(0, 0, 0, 0.5);
                    }

                    .sleek-rank {
                        width: 52px;
                        height: 52px;
                        border-radius: 10px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-weight: 700;
                        font-size: 17px;
                        color: #fff;
                        background: linear-gradient(135deg, #ff810e, #c45d00);
                        border: 1px solid rgba(255, 255, 255, 0.12);
                    }

                    .sleek-avatar {
                        width: 44px;
                        height: 44px;
                        border-radius: 50%;
                        object-fit: cover;
                        border: 2px solid rgba(255, 255, 255, 0.04);
                    }

                    .sleek-coins {
                        display: flex;
                        align-items: center;
                        gap: 8px;
                        padding: 6px 10px;
                        border-radius: 8px;
                        background: rgba(255, 255, 255, 0.05);
                        font-weight: 700;
                    }

                    .p-2 {
                        padding: 2px !important;
                    }

                    .col-9 {
                        padding-right: 25px;
                    }

                    .rules-card {
                        margin-top: 30px;
                        padding: 18px 20px;
                        border-radius: 16px;
                        background: linear-gradient(135deg, rgba(22, 22, 22, 0.9), rgba(0, 0, 0, 0.9));
                        border: 1px solid rgba(255, 255, 255, 0.11);
                    }

                    .rules-card p strong {
                        color: var(--mvp-accent-soft);
                        letter-spacing: 0.08em;
                    }

                    .rules-card ul {
                        margin-bottom: 8px;
                        color: var(--mvp-muted);
                    }

                    .rules-card li {
                        margin-bottom: 4px;
                    }

                    .mobile-sponsor-sticky {
                        display: none;
                    }

                    .flip-wrap {
                        perspective: 1000px;
                    }

                    .flip-card {
                        position: relative;
                        width: 100%;
                        aspect-ratio: 1;
                        transform-style: preserve-3d;
                        transition: transform 1s ease-in-out;
                    }

                    .auto-flip {
                        animation: flipY 15s infinite ease-in-out;
                    }

                    .flip-face {
                        position: absolute;
                        inset: 0;
                        backface-visibility: hidden;
                    }

                    .flip-face.back {
                        transform: rotateY(180deg);
                    }

                    @keyframes flipY {
                        0% { transform: rotateY(0deg); }
                        35% { transform: rotateY(0deg); }
                        55% { transform: rotateY(180deg); }
                        75% { transform: rotateY(180deg); }
                        100% { transform: rotateY(0deg); }
                    }

                    @media (max-width: 790px) {
                        .col-3 {
                            width: 40%;
                        }

                        .col-9 {
                            width: 60%;
                            padding-right: 10px;
                        }

                        .rank-ribbon {
                            width: 25px;
                            height: 30px;
                        }
                    }

                    @media (max-width: 576px) {
                        #mvp-div {
                            padding-bottom: 15px !important;
                        }

                        .mvp-header {
                            padding: 12px 10px 10px;
                        }

                        .mvp-period-switcher {
                            grid-template-columns: 78px 1fr 78px;
                            gap: 8px;
                        }

                        .mvp-nav-btn {
                            height: 38px;
                            font-size: 12px;
                            gap: 4px;
                        }

                        .mvp-nav-btn span {
                            display: none;
                        }

                        .period-name {
                            font-size: 15px;
                        }

                        .award-title {
                            font-size: 16px;
                        }

                        .award-subtitle {
                            font-size: 12px;
                        }

                        .sleek-card {
                            gap: 8px;
                            padding: 8px;
                        }

                        .sleek-rank {
                            width: 40px;
                            height: 40px;
                            font-size: 14px;
                        }

                        .sleek-avatar {
                            width: 36px;
                            height: 36px;
                        }

                        .sleek-coins {
                            padding: 4px 8px;
                            font-size: 14px;
                        }

                        .ad-strip {
                            margin-bottom: 12px;
                            font-size: 12px;
                        }

                        .sponsor-copy {
                            font-size: 12px;
                        }

                        .sponsor-cta {
                            padding: 6px 10px;
                            font-size: 11px;
                        }

                        .mobile-sponsor-sticky {
                            display: block;
                            position: fixed;
                            left: 10px;
                            right: 10px;
                            bottom: 10px;
                            z-index: 30;
                            border-radius: 12px;
                            border: 1px solid rgba(255, 129, 14, 0.6);
                            background: linear-gradient(130deg, rgba(22, 22, 22, 0.96), rgba(0, 0, 0, 0.96));
                            box-shadow: 0 12px 24px rgba(0, 0, 0, 0.45);
                            overflow: hidden;
                        }

                        .mobile-sticky-link {
                            display: flex;
                            align-items: center;
                            gap: 10px;
                            padding: 8px;
                            color: inherit;
                            text-decoration: none;
                        }

                        .mobile-sticky-logo {
                            width: 44px;
                            height: 44px;
                            border-radius: 8px;
                            object-fit: cover;
                            border: 1px solid rgba(255, 255, 255, 0.15);
                            flex-shrink: 0;
                        }

                        .mobile-sticky-copy {
                            min-width: 0;
                            flex: 1;
                        }

                        .mobile-sticky-title {
                            font-size: 10px;
                            letter-spacing: 0.12em;
                            color: #ffbf79;
                            text-transform: uppercase;
                            font-weight: 700;
                            line-height: 1.2;
                        }

                        .mobile-sticky-brand {
                            font-size: 12px;
                            color: #ffffff;
                            font-weight: 700;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                        }

                        .mobile-sticky-cta {
                            padding: 6px 10px;
                            border-radius: 999px;
                            background: linear-gradient(135deg, #ff9b30, #ff7000);
                            color: #1b140b;
                            font-size: 11px;
                            font-weight: 700;
                            border: 1px solid rgba(255, 255, 255, 0.35);
                            white-space: nowrap;
                        }
                    }

                    @media (max-width: 400px) {
                        .col-3 {
                            width: 40%;
                        }

                        .col-9 {
                            width: 60%;
                            padding-right: 10px;
                        }

                        .users-info {
                            padding: 6px 12px;
                        }
                    }
                `}</style>

                <div className="container d-flex justify-content-center">
                    <div className="col-12 col-md-10 col-lg-8 col-xl-6">
                        {is_sponser ? (
                            <>
                                <div className="sponsor-hero">
                                    <div className="sponsor-head">
                                        <span className="sponsor-tag">Sponsored by</span>
                                        <span className="sponsor-pill">{sponsorBrand}</span>
                                    </div>
                                    <a
                                        href={sponsorHref}
                                        target="_blank"
                                        rel="noreferrer"
                                        onClick={() => logEvent('MVP_SPONSER', 'CLICK', 'TOP_CHEF')}
                                        className="sponsor-media"
                                    >
                                        <img
                                            src={sponsorImage}
                                            alt={`Sponsored by ${sponsorBrand}`}
                                            className="sponsor-banner"
                                        />
                                        <div className="sponsor-overlay">
                                            <div className="sponsor-copy">Unlock this season's featured drop from {sponsorBrand}.</div>
                                            <span className="sponsor-cta">View Offer</span>
                                        </div>
                                    </a>
                                </div>
                                {/* <div className="ad-strip">
                                    Sponsor spotlight placement is active for this season and optimized for high-visibility campaign drops.
                                </div> */}
                            </>
                        ) : null}

                        <div className="mvp-stack">
                            {[1, 2, 3].map((rank) => {
                                const player = players[rank];
                                const theme = rankTheme[rank];
                                const rewardImages = Array.isArray(player.reward_img_url)
                                    ? player.reward_img_url
                                    : [player.reward_img_url, player.reward_img_url];

                                return (
                                    <div className={theme.card} key={rank}>
                                        <div className="mvp-card-body">
                                            <div className="row g-3">
                                                <div className="col-3">
                                                    <div className="rank-badge">
                                                        <div className={theme.ribbon}>
                                                            <div>{player.rank || rank}<small>{rankSuffix(player.rank || rank)}</small></div>
                                                        </div>

                                                        {animate ? (
                                                            <div className="flip-wrap">
                                                                <div className="flip-card auto-flip">
                                                                    <div className="flip-face front product-image">
                                                                        <img src={rewardImages[1] || rewardImages[0]} 
                                                                        onError={(e) => {
                                                                            e.currentTarget.onerror = null ;
                                                                            e.currentTarget.src = getViteImage('fallback/mvp.avif');
                                                                        }}
                                                                        alt="front" />
                                                                    </div>
                                                                    <div className="flip-face back product-image">
                                                                        <img src={rewardImages[0]} 
                                                                       onError={(e) => {
                                                                            e.currentTarget.onerror = null ;
                                                                            e.currentTarget.src = getViteImage('fallback/mvp.avif');
                                                                        }}
                                                                        alt="back" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <div className="product-image">
                                                                <img src={rewardImages[0]}
                                                                        onError={(e) => {
                                                                            e.currentTarget.onerror = null ;
                                                                            e.currentTarget.src = getViteImage('fallback/mvp.avif');
                                                                        }}
                                                                 alt="reward" />
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className="col-9">
                                                    <div className="award-title">{player.reward_title}</div>
                                                    <div className="d-flex justify-content-between">
                                                        <div className="award-subtitle">{player.reward_subtitle}</div>
                                                        <div className="award-subtitle" style={{ fontWeight: "600" }}>MVP Points</div>
                                                    </div>
                                                    <div className="users-info d-flex align-items-center gap-2">
                                                        <div className="user-avatar">
                                                            <img
                                                                src={getAvatarSrc(player?.profile_img, player.profile_avatar)}
                                                                alt="avatar"
                                                            />
                                                        </div>
                                                        <div className="flex-grow-1">{player.name}</div>
                                                        <div className="d-flex align-items-center gap-1"><b>{player.earned_coins}</b></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>

                        {user && Object.entries(request_user).length > 0 && request_user.rank > 0 ? (
                            <div className="sleek-card mt-3" style={{ border: '1px solid #ff810e' }}>
                                <div className="sleek-rank">{request_user.rank || '0'}{rankSuffix(request_user.rank || 0)}</div>
                                <img
                                    src={getAvatarSrc(request_user?.profile_img, request_user.profile_avatar)}
                                    className="sleek-avatar"
                                    alt="avatar"
                                />
                                <div className="flex-grow-1">{request_user.name || request_user.message || '--'}</div>
                                <div className="sleek-coins" style={{ marginRight: '15px' }}><b>{request_user.earned_coins || 0}</b> Points</div>
                            </div>
                        ) : null}

                        {is_sponser ? (
                            <div className="mobile-sponsor-sticky">
                                <a
                                    href={sponsorHref}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="mobile-sticky-link"
                                    onClick={() => logEvent('MVP_SPONSER', 'CLICK', 'TOP_CHEF_MOBILE_STICKY')}
                                >
                                    <img
                                        src={sponsorImage}
                                        alt={`${sponsorBrand} sponsor`}
                                        className="mobile-sticky-logo"
                                    />
                                    <div className="mobile-sticky-copy">
                                        <div className="mobile-sticky-title">Sponsor Spotlight</div>
                                        <div className="mobile-sticky-brand">{sponsorBrand}</div>
                                    </div>
                                    <span className="mobile-sticky-cta">Open</span>
                                </a>
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>

            <div className="container d-flex justify-content-center pd-top-60">
                <div className="rounded-bottom col-12 col-md-10 col-lg-8 col-xl-6 rules-card">
                    <p><strong>MVP RULES</strong></p>
                    <ul>
                        <li>MVP (Most Valuable Player) leaderboard and season reset at the end of each month (event cycle).</li>
                        <li>Each MVP season includes fresh incentives and campaign prizes.</li>
                        <li>Winners are determined by leaderboard rank and total MVP Points earned during the season.</li>
                        <li>The top three players at the end of each season are announced as MVP winners.</li>
                        <li>In case of a tie, the player who reaches the final score earlier ranks higher.</li>
                        <li>Only users resident in India are eligible to win physical gifts.</li>
                        <li>Players must provide a valid Indian delivery address to receive rewards.</li>
                        <li>Winners must complete the claim form in Account settings with required details.</li>
                        <li>Rewards are shipped to the winner address submitted during claim.</li>
                        <li>MVP gifts are sent within two weeks after winner confirmation.</li>
                        <li>For support or queries, contact: <a href="mailto:info@cges.club" style={{ color: "#FFB769" }}>info@cges.club</a></li>
                    </ul>
                    <p className="text-secondary m-0">
                        All contests and rewards are run by CGES.club, with featured prizes and placements supported by brand partners.
                    </p>
                </div>
            </div>
        </>
    );
}